




























































































































































































import { Vue } from "../../constants/constants";
import { ifItemSizeExist, toFixedPrice, counter } from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";
import {
  BasketLoadersEnum,
  genericErrorsEnum,
} from "../../models/basket.model";
var modalOpened = false;
export default Vue.component("basket-items", {
  data() {
    return {
      flatSizes: null,
      basketItemModal: null,
      staticContent,
      basketLoader: BasketLoadersEnum,
    };
  },
  props: {
    categories: null,
    isCurrentUserItem: null,
    editmode: null,
  },
  computed: {
    user() {
      return this.$root.user;
    },
    basketisGroup() {
      return this.$store.state.basketCompact.data.isGroup;
    },
    profile() {
      return this.$store.getters.getProfileData;
    },
    isGroupAdmin() {
      return (
        (this.profile && this.profile.uuid) ==
        this.$store.state.groupBasket.ref.adminUserUUID
      );
    },
    isGroupLocked() {
      return this.basketisGroup && this.$store.state.groupBasket.data.isLocked;
    },
    hasUpdatePermission() {
      return (
        this.editmode == "basket" &&
        (!this.basketisGroup ||
          (!this.isGroupLocked &&
            (this.isCurrentUserItem || this.isGroupAdmin)))
      );
    },
    branchShortCode() {
      return this.$store.state.basket.ref.branch.shortCode;
    },
  },
  methods: {
    flatItemExtras(extraCategories) {
      let extrasFlattened = [];
      extraCategories.forEach((exCategory) => {
        extrasFlattened = [...extrasFlattened, ...exCategory.extraItems];
      });
      return extrasFlattened;
    },
    removeItem(basketItemUUID) {
      var itemModalData = {};
      itemModalData = Object.assign(itemModalData, this.itemModalData);
      if (navigator.onLine) {
        let removeActionName = this.basketisGroup
          ? "REMOVE_ITEM_FROM_GROUP_BASKET"
          : "REMOVE_ITEM_FROM_BASKET";
        this.$store.dispatch(removeActionName, basketItemUUID).catch((err) => {
          let vue = this;
          this.$root.handleGroupError(err, function () {
            vue.$root.handleGenericErrors(
              genericErrorsEnum.item,
              "remove",
              itemModalData,
              null,
              null,
              basketItemUUID
            );
          });
        });
      } else {
        this.$root.handleGenericErrors(
          genericErrorsEnum.internet,
          "remove",
          itemModalData,
          null,
          null,
          basketItemUUID
        );
      }
    },

    displayValidExtras() {
      this.$root.$nextTick(() => {
        $("#basket-item-modal")
          .find(".extras-list.size-restricted-list")
          .each(function () {
            let $this = $(this);
            let $parent = $this.closest(".item-extras");
            $this.children().length == 0
              ? $parent.addClass("hide")
              : $parent.removeClass("hide");
          });
      });
    },

    newCalcExtrasTotalPrice(itemExtras) {
      return this.$root.newCalcExtrasTotalPrice(itemExtras);
    },
    flatItemSizes(itemsObj) {
      return this.$root.getFlatItemSizes(itemsObj);
    },
    getBasketItemModal(
      indexInOrderArray,
      basketItemUUID,
      itemUUID,
      itemSizeUUID,
      quantity,
      comment,
      extras
    ) {
      if (navigator.onLine) {
        this.$store
          .dispatch("GET_ITEM_DETAILS", [
            this.branchShortCode,
            itemUUID,
          ])
          .then(() => {
            modalOpened = true;

            this.flatSizes = this.flatItemSizes(
              this.$store.state.itemAggregate.sizes
            );
            const basketItem = this.$store.state.itemAggregate;
            const exItemsTotal = this.newCalcExtrasTotalPrice(extras);
            const flatSelectedExtras = extras.reduce(
              (extrasObj, exCategory) => {
                extrasObj[exCategory.categoryUUID] = {
                  selectedItems: exCategory.extraItems.reduce(
                    (exItemsUUIDs, item) =>
                      exItemsUUIDs.concat(item.itemSizeUUID),
                    []
                  ),
                };
                return extrasObj;
              },
              {}
            );
            this.basketItemModal = {
              flatSizes: this.flatSizes,
              flatExtraCategories: basketItem.extraCategories.reduce(
                (exCatsObj, exCat) => {
                  exCat.minimumAllowedExtra &&
                    (this.$root.itemModal.isExCatsValid = false);
                  exCatsObj[exCat.uuid] = {
                    sizeRestricted: exCat.sizeRestricted,
                    isValid: exCat.minimumAllowedExtra ? false : true,
                    minimumAllowedExtra: exCat.minimumAllowedExtra,
                    maximumAllowedExtra: exCat.maximumAllowedExtra,
                    flatSizes: exCat.items.reduce((itemsObj, item) => {
                      itemsObj = Object.assign(
                        {},
                        itemsObj,
                        item.sizes.reduce((sizeObj, size) => {
                          sizeObj[size.itemSizeUUID] = Object.assign({}, size, {
                            itemUUID: item.uuid,
                            itemName: item.name,
                            uuid: size.itemSizeUUID,
                            sizeUUID: size.sizeUUID,
                            name: size.sizeName,
                          });
                          return sizeObj;
                        }, {})
                      );
                      return itemsObj;
                    }, {}),
                    selectedItems:
                      (flatSelectedExtras[exCat.uuid] &&
                        flatSelectedExtras[exCat.uuid].selectedItems) ||
                      [],
                  };
                  return exCatsObj;
                },
                {}
              ),
              isExCatsValid: true,
              itemSubTotal:
                this.flatSizes[itemSizeUUID].price * quantity + exItemsTotal,
              itemData: Object.assign(
                {},
                {
                  quantity,
                  oldItemSizeUUID: itemSizeUUID,
                  selectedSizeUUID: itemSizeUUID,
                  comment,
                  indexInOrderArray,
                  itemUUID,
                  basketItemUUID,
                },
                basketItem
              ),
              orderExtras: extras,
            };
            this.$store.commit("updateBasketItemModal", this.basketItemModal);
            this.$nextTick(() => {
              this.calcItemSubTotal();
              this.displayValidExtras();
              this.$root.modalToggler("basket-item-modal", "show");
            });
          })
          .catch((err) => {
            let vue = this;
            this.$root.handleGroupError(err, function () {
              vue.$root.handleGenericErrors(genericErrorsEnum.generic);
            });
          });
      } else {
        this.$root.handleGenericErrors(genericErrorsEnum.internet);
      }
    },

    calcItemSubTotal() {
      this.basketItemModal.isExCatsValid = true;
      const sizeQuantityPrice = toFixedPrice(
        this.flatSizes[this.basketItemModal.itemData.selectedSizeUUID].price *
          this.basketItemModal.itemData.quantity
      );
      let extrasPrice = 0;
      let isExCatsValid = true;
      for (let exCatUUID in this.basketItemModal.flatExtraCategories) {
        let exCat = this.basketItemModal.flatExtraCategories[exCatUUID];
        if (exCat.sizeRestricted) {
          let sizes: any[] = [];
          for (let exSizeUUID in exCat.flatSizes) {
            let exSize = exCat.flatSizes[exSizeUUID];
            exSize.sizeUUID ==
              this.flatSizes[this.basketItemModal.itemData.selectedSizeUUID]
                .sizeUUID && sizes.push(exSize);
          }
          sizes.length &&
            !(exCat.minimumAllowedExtra <= exCat.selectedItems.length) &&
            (isExCatsValid = false);
        } else {
          !(exCat.minimumAllowedExtra <= exCat.selectedItems.length) &&
            (isExCatsValid = false);
        }
        extrasPrice += exCat.selectedItems.reduce(
          (sum, sizeUUID) => sum + exCat.flatSizes[sizeUUID].price,
          0
        );
      }
      this.basketItemModal = Object.assign({}, this.basketItemModal, {
        isExCatsValid,
        itemSubTotal:
          sizeQuantityPrice +
          this.basketItemModal.itemData.quantity * extrasPrice,
      });
    },
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
  },
});
